import React from "react";
import "../../styles/layouts/Main.scss";

const Courses = (props) => (
  <>
    <section className="section" id="courses">
      <p className="sectionTitle">courses</p>
      <div className="content">
        <p className="gitText">experience</p>
        <p className="coursesText">
          Junior / Regular Front-End Developer - ATMOSFERA Media <br /> JUNE to
          now
        </p>
        <p className="coursesText">
          trainee participant - Morgan Chase Software Engineering Virtual
          Experience <br /> MAY - JUNE
        </p>
        <p className="gitText">ACADEMIC EDUCATION</p>
        <p className="coursesText">
          Jagiellonian University in Cracov Faculty of Philosophy, Masters of
          Science in Clinical Psychology - Graduated in 2019
        </p>
        <p className="gitText">Conference that I took part in</p>
        <p className="coursesText">Lambda Days 13-14 FEBRUARY 2020 </p>
        <p className="gitText">Workshops</p>
        <p>Workshops on frontend programming Codecool 20 FEBRUARY 2020</p>
        <p>
          Froncik - basics of creating pages in HTML and CSS 13 FEBRUARY 2020
        </p>
        <p className="coursesText">An Ounce of Elixir 12 FEBRUARY 2020</p>
        <p className="gitText">courses</p>
        <p>
          udemy: 'JavaScript + ES6 + ES7 + ES8 + ES9 -> The Complete Guide' - in
          progress
        </p>
        <p>datacamp: Introduction to Git APRIL 2020</p>
        <p>React Challenge in 10 days 1 - 16 APRIL 2020</p>
        <p className="coursesText">
          freecodecamp: Responsive Web Design Certification 12 JANUARY - 5
          FEBRUARY 2020
        </p>
      </div>
    </section>
  </>
);

export default Courses;
